import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditModeAnnotationHelp = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#edit_mode_annotation_help_clip)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.25195 13.5H9.75195V12H8.25195V13.5ZM9.00195 1.5C4.86195 1.5 1.50195 4.86 1.50195 9C1.50195 13.14 4.86195 16.5 9.00195 16.5C13.142 16.5 16.502 13.14 16.502 9C16.502 4.86 13.142 1.5 9.00195 1.5ZM9.00195 15C5.69445 15 3.00195 12.3075 3.00195 9C3.00195 5.6925 5.69445 3 9.00195 3C12.3095 3 15.002 5.6925 15.002 9C15.002 12.3075 12.3095 15 9.00195 15ZM9.00195 4.5C7.34445 4.5 6.00195 5.8425 6.00195 7.5H7.50195C7.50195 6.675 8.17695 6 9.00195 6C9.82695 6 10.502 6.675 10.502 7.5C10.502 9 8.25195 8.8125 8.25195 11.25H9.75195C9.75195 9.5625 12.002 9.375 12.002 7.5C12.002 5.8425 10.6595 4.5 9.00195 4.5Z",
			fill: "#BDB8FF"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "edit_mode_annotation_help_clip",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white"
		})
	}) })]
});
export { SvgEditModeAnnotationHelp as ReactComponent };
